import React from 'react';
import { Icon, Card, Button, Empty, Divider, Popconfirm } from 'antd';
import { DangerousLink, Text3, Text4 } from '../../../styles';
import { PermissionHoc } from '../../HOC';
import { getBankLogo } from '../../../constants';
import { Beneficiary } from '../../../models';
import { goTo } from '../../../app_methods';

const TransferPermissableButton = PermissionHoc(Button, "TRANSFERS_INITIATE", { is_component: true, fallbackComponent: null });
const PermissablePopConfirm = PermissionHoc(Popconfirm, "BENEFICIARIES_WRITE", { is_component: true, fallbackComponent: null });

const beneficiary = new Beneficiary();

const BeneficiariesInfo = (props) => {
    const virtual_accounts = props.current_user.virtual_accounts ?? []
    const techSpec = props.current_user.virtual_account?.settings?.provider_technical_spec || {};
    const isPowerAxis = !!techSpec?.power_axis;

    const renderTitle = (beneficiary) => {
        return (
            <div className="mb-2 d-flex justify-content-between">
                <div>
                    <Icon
                        type={beneficiary.beneficiary_type === "bank_account"
                            ? "bank"
                            : beneficiary.beneficiary_type === "upi" && beneficiary.is_amazon_wallet
                                ? "amazon"
                                : "qrcode"}
                    />
                    <Text3 className="ml-2 mb-2" strong>
                        {beneficiary.beneficiary_type === "upi" && beneficiary.is_amazon_wallet
                            ? "Amazon Wallet"
                            : beneficiary.beneficiary_type_display}
                    </Text3>
                </div>

                <div className="d-flex align-items-center justify-content-end">
                    {
                        <>
                            <Button size="small" type="link" onClick={() => props.toggleBeneficiaryModal({ ...beneficiary, is_edit: true })}>Edit</Button>
                            <Divider className="h-75 m-0" type="vertical" />
                        </>
                    }
                    {beneficiary.is_active &&
                        (
                            !beneficiary.is_amazon_wallet ||
                            (beneficiary.is_amazon_wallet && beneficiary.amazon_valid)
                        ) ? (
                        <>
                            <TransferPermissableButton size="small" type="link" onClick={() => props.toggleTransferWizard(beneficiary)}>
                                Transfer
                            </TransferPermissableButton>
                            <Divider className="h-75 m-0" type="vertical" />
                        </>
                    ) : null
                    }
                    <>
                        {
                            beneficiary.is_active ?
                                <PermissablePopConfirm
                                    placement="bottomRight"
                                    title="Are you sure you want to deactivate this beneficiary account?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => props.updateStatus(beneficiary, false)}
                                >
                                    <DangerousLink size="small" type="link">Deactivate</DangerousLink>
                                </PermissablePopConfirm>
                                :
                                <PermissablePopConfirm
                                    placement="bottomRight"
                                    title="Are you sure you want to activate this beneficiary account?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => props.updateStatus(beneficiary, true)}
                                >
                                    <Button size="small" type="link">Activate</Button>
                                </PermissablePopConfirm>
                        }
                        <Divider className="h-75 m-0" type="vertical" />
                    </>
                    <Button size="small" type="link" onClick={() => goTo(`/transfers?beneficiary_id=${beneficiary?.uuid}:?beneficiary_account_name=${beneficiary?.account_name}`, props.history)}>View Transactions</Button>
                </div>
                {/* {props.is_submerchant ? 
                    <div className="d-flex align-items-center justify-content-end">
                        {
                            beneficiary.is_active ?
                                <>
                                    <TransferPermissableButton size="small" type="link" onClick={() => props.toggleTransferWizard(beneficiary)}>Transfer</TransferPermissableButton>
                                    <Divider className="h-75 m-0" type="vertical" />
                                </> : null
                        }
                        {
                            beneficiary.is_active  ?
                                <PermissablePopConfirm
                                    placement="bottomRight"
                                    title="Are you sure you want to deactivate this beneficiary account?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => props.updateStatus(beneficiary, false)}
                                >
                                    <DangerousLink size="small" type="link">Deactivate</DangerousLink>
                                </PermissablePopConfirm>
                                :
                                <PermissablePopConfirm
                                    placement="bottomRight"
                                    title="Are you sure you want to activate this beneficiary account?"
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => props.updateStatus(beneficiary, true)}
                                >
                                    <Button size="small" type="link" >Activate</Button>
                                </PermissablePopConfirm>
                        }
                    </div>
                : null} */}
            </div>
        )
    }

    const renderBeneficiaryName = (beneficiary) => {
        return (
            <div className="row">
                <div className="col-5">
                    <Text4 type="secondary" strong>Beneficiary Name:</Text4>
                </div>
                <div className="col-7">
                    <Text4>{beneficiary.account_name}</Text4>
                </div>
            </div>
        )
    }

    const renderSystemStatus = (beneficiary => {
        return (
            <div className="row">
                {beneficiary.is_amazon_wallet && (
                    <div className="col-5 mt-2">
                        <Text4 type="secondary" strong>Status:</Text4>
                    </div>
                )}
                {beneficiary.is_amazon_wallet && (
                    <div className="col-7 mt-2">
                        <Text4>{beneficiary.system_status_text}</Text4>
                    </div>
                )}
            </div>
        )
    })

    const renderBankDetails = (beneficiary) => {
        beneficiary["contact_id"] = props.contact.uuid
        const values = {
            id: beneficiary?.uuid,
            code: beneficiary?.code,
            beneficiary_name: beneficiary?.account_name,
            account_number: beneficiary?.account_number,
            ifsc: beneficiary?.account_ifsc,
            bank_code: isPowerAxis ? "POWER AXIS" : (props?.current_user?.merchant_active_on_sbi ? "SBI" : null)
        }
        const adedOnSBI = !!beneficiary?.added_on_sbi;
        const addedOnAxis = !!beneficiary?.is_power_axis
        return (
            <div>
                <div className="row">
                    <div className="col-5">
                        <Text4 type="secondary" strong>Account Number:</Text4>
                    </div>
                    <div className="col-7">
                        <Text4>{beneficiary.account_number}</Text4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-5">
                        <Text4 type="secondary" strong>IFSC Code:</Text4>
                    </div>
                    <div className="col-7">
                        <Text4>{beneficiary.account_ifsc}</Text4>
                    </div>
                </div>
                {(props?.current_user?.merchant_active_on_sbi || isPowerAxis) && (
                    <div className="row">
                        <div className="col-5">
                            <Text4 type="secondary" strong>
                                Added on Bank(s):
                            </Text4>
                        </div>
                        <div className="col-7">
                            <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                                {props?.current_user?.merchant_active_on_sbi && adedOnSBI && (
                                    <div
                                        style={{
                                            display: "flex",
                                            background: "#E6EDFF",
                                            padding: "4px 8px",
                                            borderRadius: "10px",
                                        }}
                                    >
                                        <img
                                            style={{ margin: "auto", width: "36px", height: "18px" }}
                                            alt=""
                                            src={getBankLogo("SBI")}
                                        />
                                    </div>
                                )}
                                {isPowerAxis && addedOnAxis && (
                                    <div
                                        style={{
                                            display: "flex",
                                            background: "#E6EDFF",
                                            padding: "4px 8px",
                                            borderRadius: "10px",
                                        }}
                                    >
                                        <img
                                            style={{ margin: "auto", width: "36px" }}
                                            alt=""
                                            src={getBankLogo("AXIS")}
                                        />
                                    </div>
                                )}
                                {props?.current_user?.merchant_active_on_sbi && !adedOnSBI && (
                                    <Button
                                        size="small"
                                        type="primary"
                                        loading={props.renderOTPModal === beneficiary?.uuid}
                                        onClick={() => props.renderBankOTPModal("SBI", beneficiary)}
                                    >
                                        Add SBI Bene.
                                    </Button>
                                )}
                                {isPowerAxis && !addedOnAxis && (
                                    <Button
                                        size="small"
                                        type="primary"
                                        loading={props.beneOnBankLoaderId === values?.id}
                                        onClick={() => props.addBeneficiaryOnBank(values)}
                                    >
                                        Add Axis Bene.
                                    </Button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

            </div>
        )
    };

    const renderUpiDetails = (beneficiary) => {
        return (
            <div className="row">
                <div className="col-5">
                    <Text4 type="secondary" strong>UPI VPA:</Text4>
                </div>
                <div className="col-7">
                    <Text4>{beneficiary.upi_handle}</Text4>
                </div>
            </div>
        )
    }

    const renderBeneficiaries = (beneficiaries) => {
        return beneficiaries.map(beneficiary => (
            <Card
                className={`mb-2 ${!beneficiary.is_active ? "bg-transparent" : ""}`}
                size="small"
                title={false}
            >
                {renderTitle(beneficiary)}
                {renderBeneficiaryName(beneficiary)}
                {beneficiary.beneficiary_type == "bank_account" ? renderBankDetails(beneficiary) : renderUpiDetails(beneficiary)}
                {renderSystemStatus(beneficiary)}
            </Card>
        ));
    };

    return (
        <div className="beneficiary-info-wrapper">
            {
                !props.beneficiaries.length ?
                    <Empty
                        description={
                            <Text3 className="mb-1" type="secondary">No beneficiaries for this contact.</Text3>
                        }
                    />
                    :
                    renderBeneficiaries(props.beneficiaries)
            }
        </div>
    )
};

export { BeneficiariesInfo };